<template>
    <div class="android_setting_base" v-if="isManagedGoogleDomain">
        <span>Googleアカウントでログインして端末を利用することを任意とするか、必須とするかを設定してください。<br>
            本設定は、部署別設定に加えて端末個別でも設定できます。
        </span>
        <div class="android_setting_main2">
            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">部署別設定</div>
            </div>
            <div class="android_setting_sub">
                <InputRadioWrapper v-model="workAccountSetupConfig.authenticationType" name="google-login-setting"
                    title="Googleアカウントでのログイン：" :options="loginOptions" @changeState="onChange" />
                <InfomationArea fit-content>
                    <span style="height: 40px;">
                        ・ログインには、組織で管理されているGoogleアカウントが必要です。<br />
                        ・端末個別設定が設定されている場合は、本設定より端末個別設定が優先されます。
                    </span>
                </InfomationArea>
            </div>
        </div>
        <div class="android_setting_main2">
            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">端末個別設定</div>
            </div>
            <div class="android_setting_sub">
                <span>本設定では、ログインに使用するGoogleアカウントを指定することもできます。</span>
                <button type="button" class="btn-scv-lightblue-small" style="width: 280px;"
                    @click="openAgentSettingDialog">Googleアカウントでのログイン設定</button>
                <InfomationArea fit-content>
                    <spam style="height: 20px;">
                        現在選択している部署にかかわらず、閲覧権限のある部署の端末に対しても設定を行えます。
                    </spam>
                </InfomationArea>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <GoogleAccountAgentSettingDialog v-model:show="showAgentSetting" :onPremises="onPremises" />
    </Teleport>
</template>
<script setup lang="ts">
import { ref, computed, nextTick } from 'vue';
import InputRadioWrapper from '@/views/Mobile/Android/InputRadioWrapper.vue';
import { AndroidPolicyWrapper } from '@/models/Mobile/Android/AndroidPolicyWrapper';
import * as schemaConstants from '@/models/Mobile/Android/AndroidManagementV1SchemaConstants';
import { AMAPI_WorkAccountSetupConfig } from '@/models/Mobile/Android/AndroidManagementV1Schema';
import GoogleAccountAgentSettingDialog from '@/views/Mobile/Android/GoogleAccountSetting/GoogleAccountAgentSettingDialog.vue';
import { InfomationArea } from "lib-vue-v2/components";

// --- Props ---
interface Props {
    isManagedGoogleDomain?: boolean;
    onPremises: boolean;
    disabled: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    isManagedGoogleDomain: false
});

// --- Emits ---
interface Emits {
    (e: 'notifyUpdate'): void
}
const emit = defineEmits<Emits>();

// --- State ---
const policyRef = ref<AndroidPolicyWrapper>(
    AndroidPolicyWrapper.convertDeprecatedPolicy(new AndroidPolicyWrapper())
);

const loginOptions = [
    { label: '任意', value: schemaConstants.AMAPI_AuthenticationType_Enums.authentication_type_not_enforces },
    { label: '必須', value: schemaConstants.AMAPI_AuthenticationType_Enums.googleAuthEnticated }
];

const workAccountSetupConfig = computed(() => {
    // 利用元で補完されているものとする
    return policyRef.value.policy.workAccountSetupConfig as AMAPI_WorkAccountSetupConfig;
});

// 端末個別設定ダイアログの表示／非表示
const showAgentSetting = ref(false);

// --- Methods ---
const resetUI = () => {
    // nop: 必要に応じて初期化ロジックを実装
};

/**
 * ポリシーの参照をセット（外部公開メソッド）
 */
const setPolicyRef = (policy: AndroidPolicyWrapper): void => {
    resetUI();
    nextTick(() => {
        policyRef.value = policy;
    });
};

/**
 * 変更ハンドラ
 */
const onChange = (): void => {
    emit('notifyUpdate');
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const openAgentSettingDialog = () => {
    showAgentSetting.value = true;
};

// --- External API ---
defineExpose({
    setPolicyRef
});
</script>

<style>
@import "../../../assets/css/setting.css";
@import "../../../assets/css/MobileAndroidCommon.css";
</style>

<style lang="scss" scoped>
.box-item-title {
    height: 32px;
    text-align: right;
    width: 184px;
    /* 200px - 16px(左マージン)*/
    display: flex;
    justify-content: end;
    align-items: center;
}
</style>